import Mom from "moment-timezone";

/**
 * Formats a moment instance into a date format
 *
 * @param value The moment instance
 * @param timezone The timezone we are wanting to display in
 * @param format The display format we want to use
 * @returns {string|*}
 */
export const dateFormat = (value, timezone, format = "DD/MM/YY") => {
    if (!value) {
        return '';
    }

    return Mom.tz(value, timezone).format(format);
};

/**
 * Formats a moment instance into a date/time format
 *
 * @param value The moment instance
 * @param timezone The timezone we are wanting to display in
 * @param format The display format we want to use
 * @returns {string|*}
 */
export const dateTimeFormat = (value, timezone, format = "DD/MM/YYYY HH:mm") => {
    if (!value) {
        return '';
    }

    return Mom.tz(value, timezone).format(format);
};

/**
 * Formats a moment instance into a time format
 *
 * @param value The moment instance
 * @param timezone The timezone we are wanting to display in
 * @param format The display format we want to use
 * @returns {string|*}
 */
export const timeFormat = (value, timezone, format = "hh:mm A") => {
    if (!value) {
        return '';
    }

    return Mom.tz(value, timezone).format(format);
}

export const humanFormat = (value, timezone) => {
    if (!value) {
        return '';
    }

    return Mom.tz(value, timezone).fromNow();
};

/**
 * Displays the numbers of days/hours until a given date/time from now
 * @param targetDate The target date/time
 * @param targetTimezone The timezone of the date/time we are using to calculate.  Will be UTC if coming from the DB
 * @returns {string}
 */
export const daysHoursUntilDateTime = (targetDate = null, targetTimezone = 'UTC') => {
    const now = new Date();
    const targetDateUTC = targetDate.toLocaleString('en-US', {timeZone: targetTimezone});
    const targetUTC = new Date(targetDateUTC);

    const timeDifference = targetUTC - now;

    if (timeDifference <= 0) {
        return "Closed";
    }

    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.ceil((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

    let timeString = "";

    if (days > 0) {
        timeString += `${days} day${days === 1 ? "" : "s"}`;
    }

    if (hours > 0) {
        timeString += ` ${hours} hour${hours === 1 ? "" : "s"}`;
    }

    return timeString.trim();
}



// WEBPACK FOOTER //
// ./src/Assets/components/Utility/filters/dates.js